import { Directive, Input } from '@angular/core';
import {
  NG_ASYNC_VALIDATORS,
  AsyncValidator,
  AbstractControl } from '@angular/forms';
import { AdminService } from '../services/admin.service';
import { Observable, debounceTime,  of } from 'rxjs';

@Directive({
  selector: '[appEmailValidator]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: EmailValidatorDirective,
      multi: true,
    },
  ],
})
export class EmailValidatorDirective implements AsyncValidator {
  @Input('isAddScreen') isAddScreen: boolean = false;
  @Input('userID') userID: string = '';
  constructor(private adminService: AdminService) {}

  validate(
    control: AbstractControl
  ):
    | Promise<{ [key: string]: any } | null>
    | Observable<{ [key: string]: any } | null> {
    if (control?.value && control.value != '' && !control?.errors?.['pattern'])
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          this.adminService
            .validateEMail(control.value)
            .pipe(debounceTime(10))
            .subscribe((res: any) => {
              if (res.body == null) {
                resolve(null);
              } else {
                if (res.body == this.userID && !this.isAddScreen) {
                  resolve(null);
                }
                resolve({ emailExists: true });
              }
            });
        }, 100);
      });
    return of(null);
  }
}
